import React, { useEffect, useState } from "react";
import "./FestiveWebMap.css";
import { Link, useNavigate } from "react-router-dom";
import { useGetQuests } from "../../../../../hooks/student/quest/useGetQuests";
import { usePreviewQuests } from "../../../../../hooks/web/usePreviewQuests";
import { loadStudentMapI18n } from "../../../../i18n/loaders/student.i18n";
import { useI18nLoader } from "../../../../i18n/loaders/useI18nLoader";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import { useAuth } from "../../../../context/LoginContext/AuthContext";
import { useTranslation } from "react-i18next";
import { AuthModal } from "../../../../common/AuthV2/AuthModal";
import NavigateToAddStudentPopup from "../../../../common/AuthV2/NavigateToAddStudentPopup";

export const FestiveWebMap = ({
  userType,
  isAssignedVasant,
  isAssignedShivratri,
  isAssignedDurga,
  isAssignedNavratri,
  isAssignedRakshaBandhan,
  isAssignedGaneshChaturthi,
  isAssignedDusshera,
  isAssignedOnam,
  isAssignedDiwali,
  isAssignedDhanteras,
  isAssignedDevDiwali,
  isAssignedJanamAshtami,
  isAssignedUttarayan,
  isAssignedHoli,
}) => {
  // const FESTIVE_ICONS = {
  //   23: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/vasantpanchami.png",
  //   24: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/shivratri.png",
  //   14: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/durga.png",
  //   21: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/navratri.png",
  //   15: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/devdiwali.png",
  //   17: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/rakshabandhan.png",
  //   25: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/onam.png",
  //   22: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/ganesh.png",
  //   13: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/holi.png",
  //   26: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/diwali.png",
  //   27: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/uttarayan.png",
  //   19: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dev-diwali.png",
  //   29: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/janamashtami.png",
  //   28: "https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dhanteras.png",
  // };

  const FESTIVE_CHAPTER_MAP = {
    23: 68,
    24: 67,
    14: 57,
    21: 70,
    15: 58,
    17: 60,
    25: 66,
    22: 69,
    13: 56,
    26: 65,
    27: 64,
    19: 62,
    29: 86,
    28: 63,
  };
  const { t } = useTranslation("student-map");
  const navigate = useNavigate();
  const { user } = useAuth();
  const { student } = useAuthStudent();
  const currentUser = user?.user || student?.student;
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authModalView, setAuthModalView] = useState("options");
  const [selectedQuestId, setSelectedQuestId] = useState(null);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showAddStudentModal, setShowAddStudentModal] = useState(false);
  const [selectedQuestImage, setSelectedQuestImage] = useState(null);
  const i18nReady = useI18nLoader(loadStudentMapI18n);
  const { fetchPreview, data, loading, error: newError } = usePreviewQuests();
  const { quests, error, getQuests } = useGetQuests();
  const isQuestAssigned = (questId) => {
    const quest = quests.find((q) => q.id === questId);
    return quest?.student_assigned && quest?.school_assigned;
  };
  const isSubscribed =
    currentUser?.subscription_data?.is_subscribed || currentUser?.is_subscribed;

  const getPreviewById = (id) => {
    return data.find((item) => item.id === id);
  };

  const shouldShowLock = (id) => {
    if (loading) return false;

    const item = getPreviewById(id);

    if (!item) return true;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    if (isSubscribed) return false;

    return !item.has_free_preview;
  };

  const handleQuestClick = (e, questId) => {
    e.preventDefault();

    if (loading || !data?.length) {
      return; // or show loader / toast
    }

    const item = getPreviewById(questId);
    const isFree = item?.has_free_preview;

    const isSubscribed =
      currentUser?.subscription_data?.is_subscribed ||
      currentUser?.is_subscribed;

    // const questImage = FESTIVE_ICONS[questId];
    const chapterId = FESTIVE_CHAPTER_MAP[questId];
    if (!currentUser) {
      localStorage.setItem(
        "redirectAfterLogin",
        JSON.stringify({
          questId: questId,
          isFree: isFree ?? false,
          isSubscribed: isSubscribed ?? false,
        }),
      );

      setAuthModalView("options");
      setShowAuthModal(true);
      return;
    }

    if (!isFree && !isSubscribed) {
      setSelectedQuestId(questId);
      // setSelectedQuestImage(questImage);
      setShowAddStudentModal(true);
      return;
    }

    if (!chapterId) {
      console.error("Chapter ID not found for quest:", questId);
      return;
    }

    navigate(`/student/admin/episodes/festive/detail/${questId}/${chapterId}`);
  };

  useEffect(() => {
    if (userType === "school-student") {
      getQuests("festive");
    }
  }, []);

  useEffect(() => {
    fetchPreview("festive"); // or "quest"
  }, []);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  if (!i18nReady) return null; // or loader

  return (
    <div>
      <div className="row">
        <div className="col-md-12 p-0 m-0">
          <div className="FestiveMapVasant">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedVasant
                    ? "/student/admin/episodes/festive/detail/23/68"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedVasant ? "" : "grayscale"}`}
                  src={`https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/vasantpanchami.png`}
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/23/68"
                onClick={(e) => handleQuestClick(e, 23)}
              >
                <img
                  className={`${shouldShowLock(23) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/vasantpanchami.png"
                  alt=""
                />

                {shouldShowLock(23) && (
                  <img
                    className="FestiveMapVasantLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapShivratri">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedShivratri
                    ? "/student/admin/episodes/festive/detail/24/67"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedShivratri ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/shivratri.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/24/67"
                onClick={(e) => handleQuestClick(e, 24)}
              >
                <img
                  className={`${shouldShowLock(24) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/shivratri.png"
                  alt=""
                />
                {shouldShowLock(24) && (
                  <img
                    className="FestiveMapShivratriLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapDurga">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedDurga
                    ? "/student/admin/episodes/festive/detail/14/57"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedDurga ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/durga.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/14/57"
                onClick={(e) => handleQuestClick(e, 14)}
              >
                <img
                  className={`${shouldShowLock(14) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/durga.png"
                  alt=""
                />
                {shouldShowLock(14) && (
                  <img
                    className="FestiveMapDurgaLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapNavratri">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedNavratri
                    ? "/student/admin/episodes/festive/detail/21/70"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedNavratri ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/navratri.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/21/70"
                onClick={(e) => handleQuestClick(e, 21)}
              >
                <img
                  className={`${shouldShowLock(21) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/navratri.png"
                  alt=""
                />
                {shouldShowLock(21) && (
                  <img
                    className="FestiveMapNavratriLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapDussehra">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedDusshera
                    ? "/student/admin/episodes/festive/detail/15/58"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedDusshera ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/Group+163707+(1)+(1).png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/15/58"
                onClick={(e) => handleQuestClick(e, 15)}
              >
                <img
                  className={`${shouldShowLock(15) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/Group+163707+(1)+(1).png"
                  alt=""
                />
                {shouldShowLock(15) && (
                  <img
                    className="FestiveMapDussehraLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapRaksha">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedRakshaBandhan
                    ? "/student/admin/episodes/festive/detail/17/60"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedRakshaBandhan ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/rakshabandhan.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/17/60"
                onClick={(e) => handleQuestClick(e, 17)}
              >
                <img
                  className={`${shouldShowLock(17) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/rakshabandhan.png"
                  alt=""
                />
                {shouldShowLock(17) && (
                  <img
                    className="FestiveMapRakshaLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapOnam">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedOnam
                    ? "/student/admin/episodes/festive/detail/25/66"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedOnam ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/onam.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/25/66"
                onClick={(e) => handleQuestClick(e, 25)}
              >
                <img
                  className={`${shouldShowLock(25) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/onam.png"
                  alt=""
                />
                {shouldShowLock(25) && (
                  <img
                    className="FestiveMapOnamLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapGanesh">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedGaneshChaturthi
                    ? "/student/admin/episodes/festive/detail/22/69"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedGaneshChaturthi ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/ganesh.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/22/69"
                onClick={(e) => handleQuestClick(e, 22)}
              >
                <img
                  className={`${shouldShowLock(22) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/ganesh.png"
                  alt=""
                />
                {shouldShowLock(22) && (
                  <img
                    className="FestiveMapGaneshLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapHoli">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedHoli
                    ? "/student/admin/episodes/festive/detail/13/56"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedHoli ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/holi.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/13/56"
                onClick={(e) => handleQuestClick(e, 13)}
              >
                <img
                  className={`${shouldShowLock(13) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/holi.png"
                  alt=""
                />
                {shouldShowLock(13) && (
                  <img
                    className="FestiveMapHoliLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapDiwali">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedDiwali
                    ? "/student/admin/episodes/festive/detail/26/65"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedDiwali ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/diwali.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/26/65"
                onClick={(e) => handleQuestClick(e, 26)}
              >
                <img
                  className={`${shouldShowLock(26) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/diwali.png"
                  alt=""
                />
                {shouldShowLock(26) && (
                  <img
                    className="FestiveMapDiwaliLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapUttarayan">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedUttarayan
                    ? "/student/admin/episodes/festive/detail/27/64"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedUttarayan ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/uttarayan.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/27/64"
                onClick={(e) => handleQuestClick(e, 27)}
              >
                <img
                  className={`${shouldShowLock(27) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/uttarayan.png"
                  alt=""
                />
                {shouldShowLock(27) && (
                  <img
                    className="FestiveMapUttarayanLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapDevDiwali">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedDevDiwali
                    ? "/student/admin/episodes/festive/detail/19/62"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedDevDiwali ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dev-diwali.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/19/62"
                onClick={(e) => handleQuestClick(e, 19)}
              >
                <img
                  className={`${shouldShowLock(19) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dev-diwali.png"
                  alt=""
                />
                {shouldShowLock(19) && (
                  <img
                    className="FestiveMapDevDiwaliLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapJanamashtami">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedJanamAshtami
                    ? "/student/admin/episodes/festive/detail/29/86"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedJanamAshtami ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/janamashtami.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/29/86"
                onClick={(e) => handleQuestClick(e, 29)}
              >
                <img
                  className={`${shouldShowLock(29) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/janamashtami.png"
                  alt=""
                />
                {shouldShowLock(29) && (
                  <img
                    className="FestiveMapJanamashtamiLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <div className="FestiveMapDhanteras">
            {userType === "school-student" ? (
              <Link
                to={
                  isAssignedDhanteras
                    ? "/student/admin/episodes/festive/detail/28/63"
                    : "#"
                }
              >
                <img
                  className={`${isAssignedDhanteras ? "" : "grayscale"}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dhanteras.png"
                  alt=""
                />
              </Link>
            ) : (
              <Link
                to="/student/admin/episodes/festive/detail/28/63"
                onClick={(e) => handleQuestClick(e, 28)}
              >
                <img
                  className={`${shouldShowLock(28) ? "blackgrayscale" : ""}`}
                  src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/dhanteras.png"
                  alt=""
                />
                {shouldShowLock(28) && (
                  <img
                    className="FestiveMapDhanterasLock"
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/webMap/crown.png"
                    alt=""
                  />
                )}
              </Link>
            )}
          </div>

          <img
            className="w-100"
            style={{ height: "100vh" }}
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/festive/web/festivebg.png"
            alt=""
          />
        </div>

        {/* Login Modal */}
        <AuthModal
          show={showAuthModal}
          onHide={() => setShowAuthModal(false)}
          defaultView={authModalView}
        />

        {/* NavigateToAddStudentPopup Modal */}
        <NavigateToAddStudentPopup
          modalTitle="UNLOCK FESTIVAL!"
          showModal={showAddStudentModal}
          handleClose={() => setShowAddStudentModal(false)}
          questImage={selectedQuestImage}
        />
      </div>
    </div>
  );
};
